import hljs from "highlight.js/lib/core";

import badgerQL from "hb/hljs/badgerql";
import crontab from "hb/hljs/crontab";
import bash from "highlight.js/lib/languages/bash";
import go from "highlight.js/lib/languages/go";
import http from "highlight.js/lib/languages/http";
import javascript from "highlight.js/lib/languages/javascript";
import json from "highlight.js/lib/languages/json";
import python from "highlight.js/lib/languages/python";
import ruby from "highlight.js/lib/languages/ruby";
import php from "highlight.js/lib/languages/php";
import elixir from "highlight.js/lib/languages/elixir";
import xml from "highlight.js/lib/languages/xml";
import yaml from "highlight.js/lib/languages/yaml";

hljs.registerLanguage("bash", bash);
hljs.registerLanguage("go", go);
hljs.registerLanguage("http", http);
hljs.registerLanguage("javascript", javascript);
hljs.registerLanguage("json", json);
hljs.registerLanguage("php", php);
hljs.registerLanguage("python", python);
hljs.registerLanguage("ruby", ruby);
hljs.registerLanguage("elixir", elixir);
hljs.registerLanguage("xml", xml);
hljs.registerLanguage("yaml", yaml);
hljs.registerLanguage("badgerql", badgerQL());
hljs.registerLanguage("crontab", crontab());

export default hljs;
